import {
  BooleanInput,
  DateTimeInput,
  NumberInput,
  required,
  SelectInput,
  TextInput,
  useTranslate,
  useNotify,
  FunctionField,
} from 'react-admin';
import { Box, Stack, Typography, Button, CircularProgress } from '@mui/material';
import { Resources } from '../resource';
import { useFormContext } from 'react-hook-form';
import { useRef, useState, useEffect } from 'react';
import { bannersUpload, bannersUploadByServer } from '../../services/bannersUpload';
import { bannersDataProvider } from './dataProvider';
interface FormProps {
  isCreate: boolean;
}

const BannerForm = (props: FormProps) => {
  const { isCreate } = props;
  const t = useTranslate();

  const numberProps = {
    parse: (v: any) => (v === '' || v == null ? undefined : Number(v)),
    format: (v: any) => (v == null ? '' : v),
    inputProps: {
      inputMode: 'decimal',
      step: 'any',
      onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
        (e.currentTarget as HTMLInputElement).blur();
      },
    } as const,
    onWheel: (e: React.WheelEvent) => {
      const input = (e.currentTarget as HTMLElement).querySelector('input');
      if (input) (input as HTMLInputElement).blur();
    },
  } as const;

  const { setValue, watch } = useFormContext();
  const notify = useNotify();
  const fileENInputRef = useRef<HTMLInputElement | null>(null);
  const fileENInputRef1 = useRef<HTMLInputElement | null>(null);
  const fileZHInputRef = useRef<HTMLInputElement | null>(null);
  const fileZHInputRef1 = useRef<HTMLInputElement | null>(null);
  const [uploading, setUploading] = useState(false);
  const [uploadCfg, setUploadCfg] = useState<any>(null);

  const platform = watch('platform'); //观察
  const showButton = watch('showButton');
  const enImageUrlValue = watch('enImageUrl');
  const zhImageUrlValue = watch('zhImageUrl');
  const enImage1UrlValue = watch('enImage1Url');
  const zhImage1UrlValue = watch('zhImage1Url');

  // 页面加载时请求一次 uploadCfg
  useEffect(() => {
    const fetchUploadCfg = async () => {
      try {
        const cfg = await bannersDataProvider.getUploadCfg(Resources.banners);
        setUploadCfg(cfg);
      } catch (error) {
        console.error('Failed to fetch upload config:', error);
      }
    };
    fetchUploadCfg();
  }, []);

  const handleENSelectFile = () => {
    fileENInputRef.current?.click();
  };
  const handleENSelectFile1 = () => {
    fileENInputRef1.current?.click();
  };
  const handleZHSelectFile = () => {
    fileZHInputRef.current?.click();
  };
  const handleZHSelectFile1 = () => {
    fileZHInputRef1.current?.click();
  };
  // 通用的上传函数
  const handleFileUpload = async (
    file: File,
    fieldName: string,
    inputRef: React.RefObject<HTMLInputElement>,
    setUploadingState: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    if (!uploadCfg) {
      notify('Upload config not loaded yet', { type: 'error' });
      return;
    }

    setUploadingState(true);

    try {
      const result = await bannersUploadByServer(file, {
        uploadUrl: uploadCfg?.uploadUrl,
        fileType: uploadCfg?.fileType,
        tags: uploadCfg?.tags,
        pathPrefix: uploadCfg?.pathPrefix,
        customFilename: file.name,
      });
      const uploadedUrl = result?.file?.publicURL || result?.publicURL;
      if (!uploadedUrl) {
        console.error('data structure returned by upload:', result);
        notify('upload failed image url not obtained', { type: 'error' });
        throw new Error('Upload succeeded but no url returned');
      }
      setValue(fieldName, uploadedUrl, { shouldDirty: true, shouldValidate: true });
      notify('UPLOAD SUCCESSFUL', { type: 'success' });
      return result;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error?.message || 'UPLOAD FAILED';
      notify(errorMessage, { type: 'error' });
    } finally {
      setUploadingState(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const handleENUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    await handleFileUpload(file, 'enImageUrl', fileENInputRef, setUploading);
  };
  const handleENUpload1 = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    await handleFileUpload(file, 'enImage1Url', fileENInputRef1, setUploading);
  };
  const handleZHUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    await handleFileUpload(file, 'zhImageUrl', fileZHInputRef, setUploading);
  };
  const handleZHUpload1 = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    await handleFileUpload(file, 'zhImage1Url', fileZHInputRef1, setUploading);
  };

  const formatWithToISOString = (date: Date) => {
    // 步骤1：修正时区（东八区）
    const offset = date.getTimezoneOffset() * 60000; // 东八区为-480分钟 → -28800000毫秒
    const localDate = new Date(date.getTime() - offset);

    // 步骤2：调用toISOString() + 去掉Z后缀 + 裁剪毫秒
    const isoStr = localDate.toISOString(); // 此时是东八区的ISO串：2025-12-18T16:14:00.000Z
    const formatted = isoStr.replace('.000Z', ''); // 去掉毫秒和Z → 2025-12-18T16:14:00

    return formatted;
  };

  return (
    <>
      <Stack spacing={3} gap={2}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.category')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              label={false}
              source="category"
              validate={[required()]}
              placeholder={t('module.banners.category')}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.enTitle')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              label={false}
              source="enTitle"
              placeholder={t('module.banners.enTitle')}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.zhTitle')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              label={false}
              source="zhTitle"
              placeholder={t('module.banners.zhTitle')}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.enDescription')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              label={false}
              source="enDescription"
              placeholder={t('module.banners.enDescription')}
              fullWidth
              multiline
              minRows={2}
              helperText={<span style={{ color: 'red' }}></span>}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.zhDescription')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              label={false}
              source="zhDescription"
              placeholder={t('module.banners.zhDescription')}
              fullWidth
              multiline
              minRows={2}
              helperText={<span style={{ color: 'red' }}></span>}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.route')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              label={false}
              source="route"
              validate={[]}
              placeholder={t('module.banners.route')}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.isInternalRoute')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <BooleanInput
              label=""
              source="isInternalRoute"
              helperText={<span style={{ color: 'red' }}>{''}</span>}
              format={(v) => v === true || v === 1}
              parse={(v) => v}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.platform')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <SelectInput
              source="platform"
              label={false}
              choices={[
                { id: 'PC', name: 'PC' },
                { id: 'APP', name: 'APP' },
                { id: 'H5', name: 'H5' },
              ]}
              validate={[required()]}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.enImageUrl')}
          </Typography>
          <FunctionField
            label="module.banners.enImageUrl"
            render={(record: any) => (
              <Box
                component="img"
                src={enImageUrlValue || record.enImageUrl}
                alt="Banner"
                sx={{ maxWidth: 100, maxHeight: 50, objectFit: 'contain' }}
              />
            )}
            sortable={false}
          />
          <Box sx={{ flexGrow: 1, display: 'flex', gap: 1, alignItems: 'center' }}>
            <TextInput
              label={false}
              source="enImageUrl"
              validate={[required()]}
              placeholder={t('module.banners.enImageUrl')}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
            />
            <input
              ref={fileENInputRef}
              type="file"
              accept="image/jpeg,image/png,image/gif,image/webp,image/svg" // 仅允许支持的格式
              style={{ display: 'none' }}
              onChange={handleENUpload}
            />
            <Button variant="outlined" onClick={handleENSelectFile} disabled={uploading}>
              {uploading ? <CircularProgress size={18} /> : t('module.banners.upload')}
            </Button>
          </Box>
        </Stack>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.zhImageUrl')}
          </Typography>
          <FunctionField
            label="module.banners.zhImageUrl"
            render={(record: any) => (
              <Box
                component="img"
                src={zhImageUrlValue || record.zhImageUrl}
                alt="Banner"
                sx={{ maxWidth: 100, maxHeight: 50, objectFit: 'contain' }}
              />
            )}
            sortable={false}
          />
          <Box sx={{ flexGrow: 1, display: 'flex', gap: 1, alignItems: 'center' }}>
            <TextInput
              label={false}
              source="zhImageUrl"
              validate={[required()]}
              placeholder={t('module.banners.zhImageUrl')}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
            />
            <input
              ref={fileZHInputRef}
              type="file"
              accept="image/jpeg,image/png,image/gif,image/webp,image/svg" // 仅允许支持的格式
              style={{ display: 'none' }}
              onChange={handleZHUpload}
            />
            <Button variant="outlined" onClick={handleZHSelectFile} disabled={uploading}>
              {uploading ? <CircularProgress size={18} /> : t('module.banners.upload')}
            </Button>
          </Box>
        </Stack>

        {/* {(platform === 'H5' || platform === 'APP') && (
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            spacing={2}
            mb={1}
          >
            <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
              {t('module.banners.enImage1Url')}
            </Typography>
            <FunctionField
              label="enImage1Url"
              render={(record: any) => {
                const src = enImage1UrlValue || record?.enImage1Url;
                if (!src) return null;
                return (
                  <Box
                    component="img"
                    src={src}
                    alt="Banner"
                    sx={{ maxWidth: 100, maxHeight: 50, objectFit: 'contain' }}
                  />
                );
              }}
              sortable={false}
            />
            <Box sx={{ flexGrow: 1, display: 'flex', gap: 1, alignItems: 'center' }}>
              <TextInput
                label={false}
                source="enImage1Url"
                placeholder={t('module.banners.enImage1Url')}
                fullWidth
                helperText={<span style={{ color: 'red' }}></span>}
              />
              <input
                ref={fileENInputRef1}
                type="file"
                accept="image/jpeg,image/png,image/gif,image/webp,image/svg" // 仅允许支持的格式
                style={{ display: 'none' }}
                onChange={handleENUpload1}
              />
              <Button variant="outlined" onClick={handleENSelectFile1} disabled={uploading}>
                {uploading ? <CircularProgress size={18} /> : t('module.banners.upload')}
              </Button>
            </Box>
          </Stack>
        )}

        {(platform === 'H5' || platform === 'APP') && (
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            spacing={2}
            mb={1}
          >
            <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
              {t('module.banners.zhImage1Url')}
            </Typography>
            <FunctionField
              label="zhImage1Url"
              render={(record: any) => {
                const src = zhImage1UrlValue || record?.zhImage1Url;
                if (!src) return null;
                return (
                  <Box
                    component="img"
                    src={src}
                    alt="Banner"
                    sx={{ maxWidth: 100, maxHeight: 50, objectFit: 'contain' }}
                  />
                );
              }}
              sortable={false}
            />
            <Box sx={{ flexGrow: 1, display: 'flex', gap: 1, alignItems: 'center' }}>
              <TextInput
                label={false}
                source="zhImage1Url"
                placeholder={t('module.banners.zhImage1Url')}
                fullWidth
                helperText={<span style={{ color: 'red' }}></span>}
              />
              <input
                ref={fileZHInputRef1}
                type="file"
                accept="image/jpeg,image/png,image/gif,image/webp,image/svg" // 仅允许支持的格式
                style={{ display: 'none' }}
                onChange={handleZHUpload1}
              />
              <Button variant="outlined" onClick={handleZHSelectFile1} disabled={uploading}>
                {uploading ? <CircularProgress size={18} /> : t('module.banners.upload')}
              </Button>
            </Box>
          </Stack>
        )} */}

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.startAt')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <DateTimeInput
              label={false}
              source="startAt"
              validate={[required()]}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
              // UI 显示 ISO 字符串，提交为毫秒时间戳
              format={(value: any) => {
                if (value == null || value === '') return '';
                const num = Number(value);
                const date = Number.isNaN(num) ? new Date(value) : new Date(num);
                return formatWithToISOString(date);
              }}
              parse={(value: any) => {
                if (!value) return undefined;
                const ts = new Date(value).getTime();
                return Number.isNaN(ts) ? undefined : ts;
              }}
            />
          </Box>
        </Stack>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.endAt')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <DateTimeInput
              label={false}
              source="endAt"
              validate={[required()]}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
              // UI 显示 ISO 字符串，提交为毫秒时间戳
              format={(value: any) => {
                if (value == null || value === '') return '';
                const num = Number(value);
                const date = Number.isNaN(num) ? new Date(value) : new Date(num);
                return formatWithToISOString(date);
              }}
              parse={(value: any) => {
                if (!value) return undefined;
                const ts = new Date(value).getTime(); //ms
                return Number.isNaN(ts) ? undefined : ts;
              }}
            />
          </Box>
        </Stack>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.showButton')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <BooleanInput
              label=""
              source="showButton"
              helperText={<span style={{ color: 'red' }}>{''}</span>}
              format={(v) => v === true || v === 1}
              parse={(v) => v}
            />
          </Box>
        </Stack>

        {showButton && (
          <>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretch', sm: 'center' }}
              spacing={2}
              mb={1}
            >
              <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
                {t('module.banners.enButtonText')}
              </Typography>
              <Box sx={{ flexGrow: 1 }}>
                <TextInput
                  label={false}
                  source="enButtonText"
                  placeholder={t('module.banners.enButtonText')}
                  fullWidth
                  helperText={<span style={{ color: 'red' }}></span>}
                />
              </Box>
            </Stack>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretch', sm: 'center' }}
              spacing={2}
              mb={1}
            >
              <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
                {t('module.banners.zhButtonText')}
              </Typography>
              <Box sx={{ flexGrow: 1 }}>
                <TextInput
                  label={false}
                  source="zhButtonText"
                  placeholder={t('module.banners.zhButtonText')}
                  fullWidth
                  helperText={<span style={{ color: 'red' }}></span>}
                />
              </Box>
            </Stack>
          </>
        )}

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.sortIndex')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <NumberInput
              label={false}
              source="sortIndex"
              validate={[required()]}
              placeholder={t('module.banners.sortIndex')}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
              {...numberProps}
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.banners.isActive')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <BooleanInput
              label=""
              source="isActive"
              helperText={<span style={{ color: 'red' }}>{''}</span>}
              format={(v) => v === true || v === 1} // from api data / from parse
              parse={(v) => (v ? 1 : -1)} // parse to api
            />
          </Box>
        </Stack>
      </Stack>
    </>
  );
};

// @ts-ignore
export default BannerForm;
